export default __webpack_public_path__ + "static/media/Ticket_Banner_05.3c302f5a.jpg";